import { CSSObject } from '@chakra-ui/react';

export const TextPrimary: CSSObject = {
  textTransform: 'uppercase',
  fontSize: ['2xl', '4xl'],
  fontWeight: 'normal',
  fontFamily: 'Hitchcut',
  textAlign: 'center',
  color: 'beta.400',
  textShadow: '0px 4px 8px rgba(0, 0, 0, 0.30)',
};
export const TextSecondary: CSSObject = {
  color: 'white',
  w: ['288px', null, '420px'],
  textAlign: 'center',
  p: {
    w: '100%',
    fontWeight: 'normal',
  },
};
export const ImageNoRaces: CSSObject = {
  w: ['300px', null, '478px'],
  mb: 0,
};
